import React, {useEffect, useMemo, useState} from 'react'
import {makeStyles} from "@material-ui/styles";
import DemandValidationMessages from "components/DemandValidationMessages";
import GridBlock from "components/GridBlock";
import {useParams} from "react-router";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import PurchasingGroupStage2Service from "services/PurchasingGroupStage2Service";
import Loading from "components/Loading";
import Tr from "translations/Translations";
import SplitButton, {createButton as createSplitButton} from "components/popup/components/SplitButton";
import {PurchasingGroupStageSections} from "../../../constants/PurchasingGroupStageSections";
import {ProcedureType, ProcedureTypeTr} from "constants/ProcedureType";
import {confirmComplex} from "libs/ConfirmNotification";
import useSnackbar from "hooks/useSnackbar";
import BoldTypography from "components/BoldTypography";
import {connect} from "react-redux";
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";
import Typography from "components/Typography";
import Button from "components/Button";
import RouterPath from "../../../../../../../libs/RouterPath";
import PurchasingGroupStage1Service from "../../../../../../../services/PurchasingGroupStage1Service";

const useStyle = makeStyles(theme => ({
    root: {
        width: "100%"
    }
}))

function PurchasingGroupStage2Finish(
    {
        panelRef,
        validationSection,
        stageSections
    }) {
    const classes = useStyle();
    const params = useParams();
    const groupId = params.id;
    const editable = validationSection.editable;
    const [working, setWorking] = useState(false);
    const [finishData, setFinishData] = useState(null);
    const {enqueueSuccessSnackbar, enqueueErrorSnackbar} = useSnackbar();

    const getSectionData = async () => {
        await PurchasingGroupSectionService.getSections(groupId, PurchasingGroupStageSections.FINISH)
        const section = await PurchasingGroupStage2Service.getFinish(groupId);
        if (section) {
            setFinishData(section);
        }
        return section;
    }

    useEffect(() => {
        getSectionData();
        // eslint-disable-next-line
    }, [groupId]);

    const createDemand = (type) => {

        confirmComplex({
            confirmText: Tr("create_new_procedure_confirm"),
            confirmText2: ProcedureTypeTr[ProcedureType[type]],
            onConfirm: () => {
                setWorking(true);

                PurchasingGroupStage2Service.saveFinish(groupId, {item: type}).then((resp) => {
                    if (resp) {
                        PurchasingGroupStage2Service.createDemand(resp.result).then(() => {
                            getSectionData().then(resp => {
                                if(resp.demandId && resp.hasDemandPrivilege) {
                                    RouterPath.redirect(RouterPath.createPath(RouterPath.myProcedure.steps.MP_1_ID, {id: resp.demandId}));
                                } else {
                                    PurchasingGroupStage1Service.getHeader(groupId);
                                }
                            }).finally((resp) => {
                                setWorking(false);
                                enqueueSuccessSnackbar(Tr("demand_created"))
                            });
                        })
                    }
                })
            },
            translateConfirmTexts: false
        })


    }

    const buttons = useMemo(() => finishData ? finishData.procedureTypes.map(x =>
            createSplitButton(ProcedureTypeTr[ProcedureType[x]], () => createDemand(x), !editable)) : [],
        // eslint-disable-next-line
        [finishData, editable])

    const sectionErrors = useMemo(() => {
        return Object.keys(stageSections).map(x => stageSections[x])
            .filter(x => x.section !== validationSection.section && (x.status === DemandValidationSectionStatus.ERROR || x.status === DemandValidationSectionStatus.DISABLED))
            .map(x => x.name)
    }, [stageSections, validationSection])

    const sendDealingsChangedNotification = () => {
        setWorking(true);
        PurchasingGroupStage2Service.sendDealingsChangedNotification(groupId).then(resp => {
            setWorking(false);
            if (resp && resp.result) {
                enqueueSuccessSnackbar(Tr("notification_sent"));
                PurchasingGroupSectionService.getSections(groupId, validationSection.section);
                PurchasingGroupStage2Service.getFinish(groupId).then(section => {
                    if (section) {
                        setFinishData(section);
                    }
                });
            } else {
                enqueueErrorSnackbar(Tr("unknown_error_message"));
            }
        });
    }


    return (<div className={classes.root}>
        <DemandValidationMessages editable={validationSection.editable} section={validationSection}/>

        <GridBlock
            direction='column'
            alignItems='center'
        >
            {

                !finishData ? <Loading/> :
                    <>
                        {finishData.hasDemandCreated && <BoldTypography>{Tr("demand_created")}</BoldTypography>}

                        {
                            sectionErrors.length > 0 ?
                                <Typography color="error">{`${Tr("purchase_group_finish_missing_sections")}: ${sectionErrors.join(", ")}`}</Typography>
                                :
                                <SplitButton
                                    label={Tr('create_new_procedure')}
                                    working={working}
                                    buttonClassName={classes.buttonPrint}
                                    disabled={!editable || working}
                                    buttons={buttons}
                                    variant="outlined"
                                    hideEmpty
                                />
                        }

                        {finishData.canSendDealingsChangedNotification &&
                            <Button
                                disabled={working}
                                onClick={() => sendDealingsChangedNotification()}
                            >
                                {Tr('purchase_group_finish_dealings_changed_notification_send')}
                            </Button>
                        }
                    </>
            }
        </GridBlock>
    </div>)
}

PurchasingGroupStage2Finish.propTypes = {}

export default connect((state) => ({
    stageSections: state.resources[PurchasingGroupSectionService.PURCHASING_GROUP_STAGE_SECTIONS_RESOURCE_ID]
}))(PurchasingGroupStage2Finish);